import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import General from "./general";
import Products from "./products";
import Sellers from "./sellers";

const PARENT_URL = "/cms/reports";

const Rapportage = () => {
  return (
    <Routes>
      <Route path={`/general`} element={<General />} />
      <Route path={`/products`} element={<Products />} />
      <Route path={`/sellers`} element={<Sellers />} />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/general`} replace />} />
    </Routes>
  );
};

export default Rapportage;
